import $ from 'expose-loader?exposes[]=$&exposes[]=jQuery!jquery';
import Cookies from 'js-cookie'

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: true});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: true});
    }
};

import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/tabs';
import 'jquery-ui/ui/widgets/slider';

$.ui.tabs.prototype._isLocal = () => true; //for correct cdn work;

import {readmore} from '../vendor/readmore.min';
import {slick} from 'slick-carousel';
import fancybox from '@fancyapps/fancybox'
import 'lazysizes';
import youtubeVideoInit from "../include/youtubeVideoInit";

import Inputmask from "inputmask";
import Bowser from "bowser";

// import '../vendor/jivosite.js';
// import '../vendor/textback.js';
import 'jquery.scrollto';
import '../../../../vendor/yiisoft/yii2/assets/yii.js'
import '../include/form';

import '../include/ui-dropdown';
import "../include/prettyNumber";
import "../include/zeroLastNumber";
import "../include/getRuPluralIndex";
import "../include/jsShowMore";
import {jsText} from "./jsText";
import {GaEvents} from "./gaEvents";
import {Url} from "./Url.js";
// import 'svgxuse'


$(function () {
    $.fancybox.defaults.hash=false; //fix: close button not work with <base=cdn
    // gaTargets();
    footerCreditLink();
    browserVersion();
    fixLazyloadForDatabase();
    // youtubeVideoInit();
    registerAjaxAfterLoad();
    fixedHeader();
    // uiBurger();
    // showUsedBrands();
    initFormComponent();
    initTimeoutPopup();
    initPopup();
    window.initPhoneMask();
    OpenCatalogMenu();
    // initTabs1();
    jsSlickData();
    WidgetBanner();
    banksSlider();
    showMore();
    // showMoreBrandname();
    // jsText();
    // ScrollTo();
    tooltip();
    MobileMenu();
    // window.initJivoSite();
    footerAccordion();
    filterPriceSlider();


    $(document).on('click', '.mobile .geo_link, .tablet .geo_link', function () {
        window.open(`geo:${window.app.geo[0]},${window.app.geo[1]}`, '_blank');
        if (window.app.DEV_MODE === false) {
            //yaCounter16677307.reachGoal('geo_link');
        }
    });

    yaTargets();
});

function footerAccordion() {
    $("footer .column .h6").on('click', function () {
        // вот это событие не срабатывает,
        // точнее не обновляется при компиляции скриптов
        console.log('не работает =(');
        // в консоль ничего не пишет, любые правки игнорируется на мастере
        //alert('toggled');

        $(this).parent().find("ul").slideToggle();
    });
}

function filterPriceSlider() {
    var maxPrice = parseInt($('#filter_price_max').data('max'));
    if (isNaN(maxPrice)) {
        maxPrice = 20000000;
    }

    $('#filter_price_max, #filter_price_min').on('keyup', function () {
        console.log('keyup');
        let slider = $('#selectPriceRange');
        let val_min = parseInt($('#filter_price_min').val().replace(/\s/g, ''));
        let val_max = parseInt($('#filter_price_max').val().replace(/\s/g, ''));
        if (isNaN(val_max)) {
            val_max = $(slider).slider('option', 'values')[1];
        }
        if (isNaN(val_min)) {
            val_min = 0;
        }
        console.log(val_min);
        console.log(val_max);
        $(slider).slider('values', 0, val_min);
        $(slider).slider('values', 1, val_max);
    });


    $('#selectPriceRange').slider({
        min: 0,
        max: maxPrice,
        step: 100000,
        values: [0, 6000000],
        create: function () {
            $('#filter_price_max').trigger('keyup');
        },
        slide: function (event, ui) {
            let val_min = parseInt(ui.values[0]);
            let val_max = parseInt(ui.values[1]);

            if (val_min > val_max) {
                return false;
            }

            $('#filter_price_min').val(val_min.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "));
            $('#filter_price_max').val(val_max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "));
        }

    });
    /*

        slide: function (event, ui) {
            let val = parseInt(ui.value);
            let text = ['месяц', 'месяца', 'месяцев']
            let index = window.getRuPluralIndex(val);
            $('#creditingPeriodValue').val(`${ui.value} ${text[index]}`);
            $('#sum_mounth').text(`${ui.value} ${text[index]}`);
        }
    */


}

function footerCreditLink() {
    $("#credit-conditions-link").on('click', function () {
        //не работает =(
        console.log('footer link clicked');

        //$(".credit-conditions").slideToggle();
        //return false;
    });
}

function tooltip() {
    $(document).on('click', '.tooltip', function () {
        $('.tooltiptext', this).show();

        $(document).on('click.tooltip', function (e) {
            // let $tooltip = $(e.target).parents('.tooltip');
            // if($tooltip.length === 0) {
            $('.tooltiptext').hide();
            $(document).off('click.tooltip');
            // }
        });
    });
}

function gaTargets() {
    GaEvents.init();
    $('.mobile-main .btn-call a').on('click', function () {
        GaEvents.send(GaEvents.EVENT1_PHONE);
    });
    $('.mobile-menu .header__phone-link').on('click', function () {
        GaEvents.send(GaEvents.EVENT1_PHONE);
    });


    $(document).on('click', '.btn-credit', function () {
        GaEvents.send(GaEvents.EVENT2_CREDIT);
    });
    $(document).on('click', '.btn-row-credit', function () {
        GaEvents.send(GaEvents.EVENT2_CREDIT);
    });
    window.formComponent.forms['card_popup_credit_used'] = {
        onAjaxComplete: function (context) {
            window.formComponent.onAjaxComplete(context);
            GaEvents.send(GaEvents.EVENT3_CREDIT);
        }
    };
    window.formComponent.forms['card_popup_credit_new_ticket'] = {
        onAjaxComplete: function (context) {
            window.formComponent.onAjaxComplete(context);
            GaEvents.send(GaEvents.EVENT3_CREDIT);
        }
    };

    $(document).on('click', '.btn-rezerv', function () {
        GaEvents.send(GaEvents.EVENT4_RESERVE);
    });
    $(document).on('click', '.btn-row-cash', function () {
        GaEvents.send(GaEvents.EVENT4_RESERVE);
    });
    window.formComponent.forms['card_used_reserve'] = {
        onAjaxComplete: function (context) {
            window.formComponent.onAjaxComplete(context);
            GaEvents.send(GaEvents.EVENT5_RESERVE);
        }
    };
    window.formComponent.forms['card_new_cash'] = {
        onAjaxComplete: function (context) {
            window.formComponent.onAjaxComplete(context);
            GaEvents.send(GaEvents.EVENT5_RESERVE);
        }
    };


    $(document).on('click', '.btn-tradein', function () {
        GaEvents.send(GaEvents.EVENT6_TRADEIN);
    });
    window.formComponent.forms['card_used_tradein'] = {
        onAjaxComplete: function (context) {
            window.formComponent.onAjaxComplete(context);
            GaEvents.send(GaEvents.EVENT7_TRADEIN);
        }
    };
    window.formComponent.forms['card_new_tradein'] = {
        onAjaxComplete: function (context) {
            window.formComponent.onAjaxComplete(context);
            GaEvents.send(GaEvents.EVENT7_TRADEIN);
        }
    };


    window.formComponent.forms['form_backcall'] = {
        onAjaxComplete: function (context) {
            window.formComponent.onAjaxComplete(context);
            GaEvents.send(GaEvents.EVENT11_WIDGET);
        }
    };

}

function browserVersion() {
    try {
        window.Bowser = Bowser.getParser(window.navigator.userAgent);
        $('body')
            .addClass(window.Bowser.getOSName().toLowerCase())
            .addClass(window.Bowser.getPlatform().type)
            .addClass(window.Bowser.getBrowserName().toLowerCase())
            .addClass(`v${window.Bowser.getBrowserVersion().replace(/\..+/g, '')}`)
    } catch (e) {
        console.error(e);
    }
}

function fixLazyloadForDatabase() {
    $('img[data-original]').each(function (i, e) {
        let $img = $(e);
        $img.attr('data-src', $img.data('original')).addClass('lazyload');
    });
}

function registerAjaxAfterLoad() {
    $(document).on('ajaxAfterLoad', function () {
        console.log('ajaxAfterLoad');
        window.initPhoneMask();
    });
}

function uiBurger() {
    $('#burger').click(function () {
        $(this).toggleClass('open');
        $('.mobile-menu').slideToggle();
        let $header = $('.header-mobile .catalog-menu-btn');
        if ($header.hasClass('open')) {
            $('.header-mobile .catalog-menu').toggleClass('hidden');
            $header.toggleClass('open');
        }
    });
}

function OpenCatalogMenu() {
    $(document).on('click', '#catalog-menu-btn', function () {
        let thisMenu = $('#catalog-menu');
        thisMenu.toggleClass('d-hide');
        $(this).toggleClass('open');
        let $burger = $('#burger');
        if ($burger.hasClass('open')) {
            $burger.toggleClass('open');
            $('.mobile-menu').slideToggle();
        }
    });
}


function showUsedBrands() {
    $('.show-brands').click(function () {
        $(this).hide();
        $('.brands-used .brands').slideToggle({
            duration: 100,
            easing: "linear",
            start: function () {
                jQuery(this).css('display', 'flex');
            }
        });
        return false;
    });
}

function fixedHeader() {
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('header').addClass('sticky');
        } else {
            $('header').removeClass('sticky');

        }

        // else if ($('.header-mobile').is(":visible")) {
        //     if ($(this).scrollTop() > 59) {
        //         $('.header-mobile').css('position', 'fixed');
        //     } else {
        //         $('.header-mobile').css('position', 'relative');
        //     }
        // }
    });
}


function initFormComponent() {
    window.formComponent.init();
    window.formComponent.onElementFail = function (context) {
        let errorClass = context.$element.data('errorclass');
        let errorMessage = context.$element.data('errormessage');
        context.$element.addClass(errorClass);
        context.$element.parent().append('<p class="form__error">' + errorMessage + '</p>');
        context.$element.one('focus', function () {
            context.$element.removeClass(errorClass);
            $('.form__error', context.$form).remove();
        });
    };
    window.formComponent.onAjaxComplete = function (context) {
        $.fancybox.close();

        if(context.response.spam && context.response.spam === true) {
            context.$form[0].reset();
            return
        }
        if (context.response.html === undefined) {
            alert('Произошла ошибка! Повторите попытку, или оставьте заявку по телефону.')
        }

        let sendCounters = function () {
            try {
                gtag('event', 'send', {
                    'event_category': 'form_send',
                    'event_label': 'ok'
                });
            } catch (e) {
                console.error(e);
            }

            try {
                ym(94735519, 'reachGoal', 'form_send')
            } catch (e) {
                console.error(e);
            }

            try {
                let $input = $('input[name=ya_target_id]', context.$form);
                if ($input.length) {
                    let targetName = $input.val();
                    //yaCounter16677307.reachGoal(targetName);
                    console.log(`sended yandex target ${targetName}`);
                } else {
                    console.log('yandex target not found for form', context.$form);
                }
            } catch (e) {
                console.error(e);
            }
        }

        let formFields = {};
        for (const pair of context.data.entries()) {
            formFields[pair[0].toLowerCase()] = pair[1];
        }

        if (!formFields['tickets[phone]']) {
            return;
        }

        let formData = {
            phone: formFields['tickets[phone]']
        };

        if (formFields['tickets[name]']) {
            formData.name = formFields['tickets[name]']
        }
        if (formFields['tickets[form_name]']) {
            formData.form_name = formFields['tickets[form_name]']
        }
        if (formFields['tickets[other][comment]']) {
            formData.message = formFields['tickets[other][comment]'];
        }

        if (window.app.DEV_MODE === false) {
            // this moved code after onAjaxAlways when button block already released.
            // then we can block\unblock again
            setTimeout(() => {
                let event1 = setTimeout(() => {ym(94735519,'reachGoal','uis_sec1');}, 1000);
                let event2 = setTimeout(() => {ym(94735519,'reachGoal','uis_sec2');}, 5000);

                context.$button.block(true);
                window.Comagic.addOfflineRequest(formData, function (o) {
                    context.$button.block(false);
                    if (o instanceof XMLHttpRequest) {
                        o = JSON.parse(o.response);
                    }

                    if (o.success) {
                        $.fancybox.open(context.response.html.success);
                        context.$form[0].reset();
                        sendCounters();
                    } else {
                        $.fancybox.open(context.response.html.error);
                    }
                    clearTimeout(event1);
                    clearTimeout(event2);
                });
            }, 0)
        } else {
            $.fancybox.open(context.response.html.success);
            context.$form[0].reset();
        }
    }
    window.formComponent.onBeforeValidate = function (context) {
        let $promo = $('.roistat-promo');
        if ($promo) {
            let $inputs = $('.form_promocode');
            if ($inputs) $inputs.val($promo.text());
        }
        /** for remove doubles */
        $('.form__error', context.$form).remove();
    };
    window.formComponent.onFormFail = function (context) {
        let error_fields = $('.form__error', context.$form);
        error_fields.slideDown();
    };
}

function initTimeoutPopup() {

    setTimeout(function () {
        $("#timeout_popup2").trigger('click');
    }, 30000);
    setTimeout(function () {
        if ($("#form_deal").length == 0) {
            $("#timeout_popup").trigger('click');
        }
    }, 90000);

}

function initPopup() {

    try {
        $('#popup-banner1').attr('data-popup-url', '/api/popup/banner1');
    } catch (e) {
    }

    $(document).on('click', '[data-popup-url]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let $self = $(this);
        if ($self.attr('disabled')) {
            return;
        }
        $self.attr('disabled', true);

        let $block = $self.parents('[data-block-name]');
        let form_name = $block ? $block.data('block-name') : '';

        let urlData = {
            loc_path: window.location.pathname,
            form_name: form_name
        };
        let id = $self.data('popup-id');
        let href = $self.data('popup-url');
        let fn = $self.data('popup-fn');
        let iframeUrl = $self.data('popup-iframe');

        if (window[fn]) {
            window[fn].apply(this, [urlData]);
        }

        $.post({
            url: Url.to(href),
            data: urlData
        }).then(function (response) {
            $.fancybox.open(response, {
                touch: false,
                autoFocus: false,
                animationEffect: false,
                hideScrollbar: false,
                afterLoad: function () {
                },
                afterShow: function () {
                    $(document).trigger('ajaxAfterLoad');
                    if (id === 'map') {
                        window.ymaps.ready(initYandexMap);
                    }
                },
            });
            $self.attr('disabled', false);
        }).fail(function (r, s, e) {
            $self.attr('disabled', false);
            console.error(r, s, e);
        });

        if ($self.hasClass('in-iframe')) {

            console.log(iframeUrl);
            $("#in-iframe").attr("src-add", iframeUrl);
            $(".fancybox-content").addClass('.popup-uds');
        }

    });
}

window.initPhoneMask = function (selector = 'input[data-role="phone"]') {
    let mask = "+7 (N99) 999-99-99";

    let hostParts = window.location.host.toLowerCase().split('.');

    if (hostParts.length === 3) {
        if (hostParts[0] === 'belarus') {
            mask = "+375 (99) 999-99-99";
        }
    }

    Inputmask({
        mask: mask,
        definitions: {
            "N": {
                validator: "[49]",
            }
        },
        showMaskOnHover: false,
        clearIncomplete: true
    }).mask($(selector).toArray());
}

function initYandexMap() {
    let myMap = new window.ymaps.Map("modal-map", {
        center: [window.app.geo[0], window.app.geo[1]],
        zoom: 16
    });
    let myPlacemark = new window.ymaps.Placemark(myMap.getCenter(), {
        hintContent: `Автосалон ${app.text.dealerName}`,
        balloonContent: app.text.dealerAddress,
    }, {
        preset: 'islands#redAutoIcon',
    });
    myMap.geoObjects.add(myPlacemark);
}

// in the future
function OpenCallbackForm() {
    $(document).on('click', '.js-open-callback', function () {
        $(this).parent().hide();
        $('.open-callback').css('display', 'block');
    });
}

function initTabs1() {
    $("#jtabs_v1").tabs({
        active: 0,
    });
}

function jsSlickData() {
    $('.js-slick-data').slick();
}

function banksSlider() {
    let SliderBanks = $('.' +
        'js-slider-banks');

    SliderBanks.slick({
        rows: (SliderBanks.parent().parent('.banks').hasClass('min') == true) ? 1 : 2,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
            breakpoint: 1280,
            settings: {
                slidesToShow: 8,
                slidesToScroll: 8
            }
        }, {
            breakpoint: 1024,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 6
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 400,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }]
    });

}

function WidgetBanner() {
    $('.WidgetBanner').slick({});
}

function showMore() {
    $('.text-show-more').readmore({
        speed: 20,
        collapsedHeight: 110,
        moreLink: '<div class="show-more close"><span>Подробнее..</span><img src="/assets/images/ico/arrow.svg" alt=""/></div>',
        lessLink: '<div class="show-more open"><span>Свернуть</span><img src="/assets/images/ico/arrow.svg" alt=""/></div>'
    });
}

function showMoreBrandname() {
    $('.showMore-box').each(function () {
        let boxHeight = $(this).outerHeight();
        let boxHeightClose = $(this).data('height');
        if (boxHeight > boxHeightClose) {
            $(this).addClass('closed');
            $(this).css('max-height', boxHeightClose + 'px');
            $(this).after("<div class='showMore-btn closed'></div>");
        }
    });
    $('.showMore-btn').on('click', function () {
        $(this).prev().toggleClass('closed');
        $(this).prev().toggleClass('open');
        $(this).toggleClass('closed');
    });

}

function ScrollTo() {
    $(".js-scroll").on('click', function () {
        let target = $(this).attr('href');
        $.scrollTo(target, 1000);
        // console.log('scroll-to');
    });

}

function MobileMenu() {
    $(document).on('click touch', '.off-canvas-toggle', function () {
        //$('#sidebar-id').toggleClass('active');
        $(this).addClass('close');
    });

    $(document).on('click touch', '.off-canvas-overlay', function () {
        $(".off-canvas-toggle.close").removeClass('close');
        //$('#sidebar-id').removeClass('active');
    });


}

function yaTargets() {

    let interval = setInterval(function () {
        let cookie_value = Cookies.get('spent_time');

        if (cookie_value >= 120) {
            clearInterval(interval)
            console.info('spent_time', 'stop')
        } else if (cookie_value >= 1) {
            cookie_value = parseInt(cookie_value) + 1;
            Cookies.set('spent_time', cookie_value);
            console.info('spent_time', 'next', cookie_value)
        } else {
            Cookies.set('spent_time', 1);
            console.info('spent_time', 'start')
        }

        if (cookie_value == 60) {
            ym(94735519, 'reachGoal', 'spent_time60')
            console.info('spent_time', 60)
        }
        if (cookie_value == 90) {
            ym(94735519, 'reachGoal', 'spent_time90')
            console.info('spent_time', 90)
        }
        if (cookie_value == 120) {
            ym(94735519, 'reachGoal', 'spent_time120')
            console.info('spent_time', 120)
        }
    }, 1000)

    if (window.location.href.search(`${window.location.origin}/credit`) === 0) {
        ym(94735519, 'reachGoal', 'page_credit')
    }
    if (window.location.href.search(`${window.location.origin}/tradein`) === 0) {
        ym(94735519, 'reachGoal', 'page_tradein')
    }
}

